import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { environment } from '#environments/environment';

export interface Company {
  companyId: string;
  legalData: {
    companyName: string;
  };
  companyIdentifiers: {
    idTypeCode: string;
    idValue: string;
    priorityNumber: number;
  }[];
  address: {
    countryCode: string;
    town: string;
    streetName: string;
    streetNumber: string;
    postCodes: { postCodeValue: string }[];
  };
}

@Injectable({
  providedIn: 'root',
})
export default class CompanyService {
  private readonly httpClient = inject(HttpClient);

  async getCompanyDetails(companyId: string | undefined) {
    if (!companyId) return;
    try {
      return await lastValueFrom(this.httpClient.get<Company>(`${environment.companyRefUrl}/companies/${companyId}`));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      if (e?.status === 404) {
        return undefined;
      }
      throw e;
    }
  }

  postCompanySearch(countryCode: string, companyName: string) {
    return lastValueFrom(
      this.httpClient.post<{ results: { company: Company }[] }>(
        `${environment.companySearchUrl}/companies/advancedSearch`,
        {
          countryCode,
          companyName,
        },
      ),
    );
  }
}
